import { create } from 'zustand';

interface ThemeState {
  antdThemeColor?: string;
  bgColor: string;
  mainLayoutHeaderTextColor: string;
  mainLayoutHeaderUserSpaceIcon: number;
  mainLayoutHeaderUserSpaceBg: string;
  mainLayoutHeaderUserSpaceSpanBg: string;
  hasMainLayoutHeaderBg?: boolean;

  stepBlockBgColor: string;
  stepBlockTextColor: string;

  sidePanelLinkColor: string;

  fileCardBgColor: string;
  fileCardBorder: string;
  fileCardBorderActiveColor: string;
  fileCardBgPng: number;
  fileCardSmartGeneratePng: number;

  chatSendBtnBgColor: string;
  chatSendBtnBgHoverColor: string;

  chatSenderBorder: string;
  chatSenderBgColor?: string;
  chatBubbleLoadingSvg: number;
  chatSenderResetFormButtonBg: string;
  chatSenderResetFormButtonBefore: string;
  chatSenderResetFormButtonHoverBg: string;
  chatSenderResetFormButtonIcon: number;

  thinkDeeplyBtnColor: string;
  thinkDeeplyBtnBorder: string;
  thinkDeeplyBtnBgColor: string;
  thinkDeeplyBtnHoverColor: string;
  thinkDeeplyBtnBgHoverColor: string;
  thinkDeeplyActiveIcon: number;
  hasMainLayoutSiderBg?: boolean;
  mainLayoutSiderContentColor: string;
  mainLayoutSiderContentBg: string;
  mainLayoutSiderContentBorder: string;
  mainLayoutSiderContentIcon: number;
  mainLayoutSiderContentSelectedBg?: string;
  mainLayoutSiderContentSelectedColor?: string;

  mainLayoutSiderHistorySessionIcon: number;
  mainLayoutSiderHistorySessionIconBg: string;
  mainLayoutSiderHistorySessionCurrent: string;
  mainLayoutSiderHistorySessionText: string;

  teachingPlanFormLessonIcon: number;
  teachingPlanFormUnitIcon: number;
  agentFormHeaderCardBorderColor: string;
  agentFormHeaderCardBackgroundColor: string;
  agentFormBodySwitchColor: string;
  agentFormBodyRadioCheckboxColor: string;
  agentFormActionDownBorderColor: string;
  agentFormActionDownColor: string;
  agentFormActionDownHoverColor: string;
  teachingPlanFormActionButtonBackgroundColor: string;
  teachingPlanFormActionButtonHoverColor: string;

  commonTabGroupColor: string;
  coursewareCreateButtonBgColor: string;
  coursewareCreateButtonBgHoverColor: string;
  coursewareGotoCommunityImg: number;

  coursewareEmptyActionTextColor: string;
  coursewareEmptyBgColor: string;
  coursewareEmptyCollaboratedImg: number;
  coursewareEmptyUsedImg: number;
  dropDownMeunColor: string;

  coursewarePublishButtonBgColor: string;
  coursewarePublishButtonBgHoverColor: string;

  coursewareDetailBgColor: string;
  coursewareDetailBorder?: string;
  coursewareScenesStepsBgColor?: string;

  coursewareInfoTabsActiveColor: string;
  emptyQualityImg: number;
  emptyUnitKnowledgePointImg: number;

  coursewareDetailCenterModuleIntroCardBgColor: string;

  moduleIntroUnitGuideDividerBgColor: string;
  moduleIntroModelDividerBgColor: string;

  filterBorderColor: string;
  filterHoverBodrderColor: string;
  filterActiveBorderColor: string;

  resourceCreationUploadBorder: string;
  resourceCreationUploadHoverBorder: string;
  resourceCreationUploadBgColor: string;
  resourceCreationUploadHoverBgColor: string;
  resourceCreationUploadDragIconColor: string;
  resourceCreationUploadProgressStartColor: string;
  resourceCreationUploadProgressEndColor: string;
  resourceCreationBtnBgColor: string;
  resourceCreatButtonBgColor: string;
  resourceCreatButtonHoverBgColor: string;

  hasChatWelcomeTitleBg?: boolean;
  chatToolListConfig: number;
  chatToolListItemBg?: string;
  chatToolListItemTagBg: string;
  chatToolListItemTextColor: string;

  loginSignInBackground?: number;
  loginSignInSlogan?: boolean;
  loginSignInFormTitle?: string;
  hasLoginSignInFormLogo?: boolean;
  loginSignInSubjectSelect?: boolean;
  loginSignInCaptchaButtonColor?: string;
  loginSignInAgreement?: 'ipe';
  loginSignInAgreementCheckboxColor?: string;
  loginSignInFormBackground?: number;

  hiddenLogo?: boolean;

  settingsLeftNavPersonalIcon: number;
  settingsLeftNavSchoolIcon: number;
  settingsLeftNavAccountIcon: number;
  settingsLeftNavAboutIcon: number;
  settingsAboutTextColor: string;
  settingsAboutTextHoverColor: string;
  settingsPersonalAvatarBg: string;
  settingsPersonalButtonBg: string;
  settingsAboutTitle: string;
  settingsContractItemTitle: string;
  settingsAboutAgreement?: 'ipe';

  notFoundIcon: number;

  aiPptChatHistoryFavoritesIcon: number;
  aiPptChatHeaderFavoritesIcon: number;
  aiPptChatLeftButtonIcon: number;
  aiPptChatLeftButtonBg: string;
  aiPptChatLeftButtonColor: string;
  aiPptChatLeftButtonBorder: string;
  aiPptChatSendButtonIcon: number;
  aiPptChatDeepCreationButtonColor: string;
  aiPptChatDeepCreationButtonBg: string;
  aiPptChatDeepCreationButtonHoverBg: string;
  aiPptChatDeepCreationButtonIcon: number;
  aiPptChatGenerateButtonIcon: number;
  aiPptChatGenerateButtonHoverColor: string;
  hasAiPptChatDeepCreationDialogDescribe?: boolean;

  moduleTabsBgColor: string;
  moduleTabsHoverBgColor: string;
  moduleTabsBorder?: string;
  moduleTabsActiveColor?: string;
  moduleTabsUnitGuideColor?: string;
  moduleTabsModuleIcon?: number;

  playerBackgroundColor?: string;
  playerIntroBoxColorBar?: number;
  playerGuideButtonIcon?: number;
  playerDigitalHumanBoxBg?: number;
  playerColourStyle?: number;
  playerEmptyImage?: number;
  unitGuideLayoutstyle?: number;

  pageLoadingSuit?: number;

  resourceUnitGuideIcon: number;
  resourceUnitGuideBg: string;
  resourceCommunityTextColor: string;
  resourceQuickCreateImage: number;
  resourceQuickUploadImage: number;
  resourceEmptyScaffoldImage: number;
  resourceEmptyTeachingImage: number;
  resourceEmptyCoursewareImage: number;

  emptyWithCreateQuickPanBgColor: string;

  pptAddedButtonsBgColor: string;
  pptToolbarAddedBgColor: string;

  scaffoldingBgColors?: string;
  scenesStepTabsStyle?: number;
  sceneStepTabsIcon?: number;

  communityCoursewareImage: number;
  communityCoursewareBg: string;

  courseWareInfiniteCardButtonColor: string;
  courseWareInfiniteCardButtonColorHover: string;
  courseWareInfiniteCardButtonIcon: number;
  courseWareInfiniteCardUseButtonColor: string;
  courseWareInfiniteCardUseButtonColorHover: string;
  courseWareInfiniteCardUseButtonIcon: number;
  courseWareInfiniteCardUseButtonBorder: string;
  courseWareInfiniteCardUseButtonFontColor: string;

  learningSpaceDocumentBg: string;
  learningSpaceDocumentImage: number;

  agentMaterialBgImage: number;
  agentMaterialTextColor: string;
}

const useThemeStore = create<ThemeState>()(() => ({
  bgColor: '#ffffff',
  mainLayoutHeaderTextColor: '#222',
  mainLayoutHeaderUserSpaceIcon: 0,
  mainLayoutHeaderUserSpaceBg: '#f9f9f9',
  hasMainLayoutHeaderBg: undefined,

  stepBlockBgColor: 'rgba(66, 143, 255, 0.12)',
  stepBlockTextColor: 'rgba(59, 102, 255, 1)',
  sidePanelLinkColor: '#1677ff',

  fileCardBgColor:
    'linear-gradient(90deg,rgba(255, 255, 255, 1) 50%,rgba(243.8274688720703, 248.3792724609375, 255, 1) 100%)',
  fileCardBorder: '1px solid rgba(0, 0, 0, 0.08)',
  fileCardBorderActiveColor: 'rgba(66, 143, 255, 1)',
  fileCardBgPng: 0,
  fileCardSmartGeneratePng: 0,

  chatSendBtnBgColor: 'rgba(66, 143, 255, 1)',
  chatSendBtnBgHoverColor: 'rgba(65, 115, 207, 1)',

  chatSenderBorder: '0.8px solid transparent',
  chatSenderBgColor:
    'linear-gradient(90deg, rgba(207, 32, 249, 1), rgba(255, 84, 13, 1), rgba(0, 128, 255, 1))',
  chatBubbleLoadingSvg: 0,
  chatSenderResetFormButtonBg:
    'linear-gradient(to right, #fdf8fd, #fcf5f3, #f8fbfe)',
  chatSenderResetFormButtonBefore:
    'linear-gradient(90deg, #f2e1f7, #f6dbce, #dde9f8)',
  chatSenderResetFormButtonHoverBg: `linear-gradient(90deg, #faf1fc, #fce9e0, #edf5ff),
            rgba(255, 255, 255, 1)`,
  chatSenderResetFormButtonIcon: 0,

  thinkDeeplyBtnColor: 'rgba(66, 143, 255, 1)',
  thinkDeeplyBtnBorder: '1px solid rgba(66, 143, 255, 0.3)',
  thinkDeeplyBtnBgColor: 'rgba(66, 143, 255, 0.1)',
  thinkDeeplyBtnHoverColor: '#579aff',
  thinkDeeplyBtnBgHoverColor: 'rgba(197, 219, 255, 1)',
  thinkDeeplyActiveIcon: 0,
  mainLayoutHeaderUserSpaceSpanBg: '#3a6de9',

  mainLayoutSiderContentColor: 'rgba(16, 111, 250, 1)',
  mainLayoutSiderContentBg: 'rgba(66, 143, 255, 0.12)',
  mainLayoutSiderContentBorder: 'rgba(66, 143, 255, 0.25)',
  mainLayoutSiderContentIcon: 0,

  mainLayoutSiderHistorySessionIcon: 0,
  mainLayoutSiderHistorySessionIconBg: 'rgba(66, 143, 255, 0.12)',
  mainLayoutSiderHistorySessionCurrent: 'rgba(66, 143, 255, 0.12)',
  mainLayoutSiderHistorySessionText: 'rgba(16, 111, 250, 1)',

  teachingPlanFormLessonIcon: 0,
  teachingPlanFormUnitIcon: 0,
  agentFormHeaderCardBorderColor: 'rgba(66, 143, 255, 1)',
  agentFormHeaderCardBackgroundColor: 'rgba(66, 143, 255, 0.08)',
  agentFormBodySwitchColor: 'rgba(111, 168, 252, 1), rgba(55, 114, 232, 1)',
  agentFormBodyRadioCheckboxColor: ' rgba(66, 143, 255, 0.65)',
  agentFormActionDownBorderColor: '#428fff, #9fc6ff',
  agentFormActionDownColor: 'rgba(16, 143, 250, 1)',
  agentFormActionDownHoverColor: 'rgba(227, 238, 255, 1)',
  teachingPlanFormActionButtonBackgroundColor: '#428fff',
  teachingPlanFormActionButtonHoverColor: '#68a6ff',

  commonTabGroupColor: 'rgba(66, 143, 255, 1)',

  coursewareCreateButtonBgColor: '#428FFF',
  coursewareCreateButtonBgHoverColor: '#68A5FF',
  coursewareGotoCommunityImg: 0,

  coursewarePublishButtonBgColor: '#428fff',
  coursewarePublishButtonBgHoverColor: '#68a5ff',

  coursewareEmptyActionTextColor: '#4492ff',
  coursewareEmptyBgColor: '#f7f8fa',
  coursewareEmptyCollaboratedImg: 0,
  coursewareEmptyUsedImg: 0,
  dropDownMeunColor: '#428fff',

  coursewareDetailBgColor: 'rgba(66, 143, 255, 0.12)',

  coursewareDetailCenterModuleIntroCardBgColor: 'rgba(255, 255, 255, 0.6)',

  coursewareInfoTabsActiveColor: '#25282B',
  emptyQualityImg: 0,
  emptyUnitKnowledgePointImg: 0,

  moduleIntroUnitGuideDividerBgColor: 'rgba(254, 157, 135, 1)',
  moduleIntroModelDividerBgColor:
    'linear-gradient(90.00deg, rgba(171, 217, 105, 1),rgba(137, 99, 252, 1) 16%,rgba(87, 183, 205, 1) 32%,rgba(255, 181, 213, 1) 48%,rgba(244, 218, 94, 1) 64%,rgba(254, 157, 135, 1) 80%,rgba(146, 180, 246, 1) 100%)',

  filterBorderColor: '#C7C7C7',
  filterHoverBodrderColor: '#428FFF',
  filterActiveBorderColor: '#428FFF',

  resourceCreationUploadBorder: '1px dashed rgba(104, 165, 255, 1)',
  resourceCreationUploadHoverBorder: '1px dashed rgba(66, 143, 255, 1)',
  resourceCreationUploadBgColor: 'rgba(66, 143, 255, 0.06)',
  resourceCreationUploadHoverBgColor: 'rgba(66, 143, 255, 0.06)',
  resourceCreationUploadDragIconColor: '#428fff',
  resourceCreationUploadProgressStartColor: '#649AFF',
  resourceCreationUploadProgressEndColor: '#056BEC',
  resourceCreationBtnBgColor: 'rgba(66, 143, 255, 1)',
  resourceCreatButtonBgColor: '#428FFF',
  resourceCreatButtonHoverBgColor: '#68A5FF',

  emptyWithCreateQuickPanBgColor: 'rgba(246, 247, 249, 1)',

  chatToolListConfig: 0,
  chatToolListItemTagBg:
    'linear-gradient( 90deg, rgba(199, 230, 255, 1),  rgba(218, 216, 255, 1) 46%, rgba(255, 243, 240, 1) 100% );',
  chatToolListItemTextColor: 'rgba(77, 75, 183, 1)',

  hasLoginSignInFormLogo: true,

  settingsLeftNavPersonalIcon: 0,
  settingsLeftNavSchoolIcon: 0,
  settingsLeftNavAccountIcon: 0,
  settingsLeftNavAboutIcon: 0,
  settingsAboutTextColor: '#1677ff',
  settingsAboutTextHoverColor: '#69b1ff',
  settingsPersonalAvatarBg: '#3a6de9',
  settingsPersonalButtonBg: '#3a6de9',
  settingsAboutTitle: '卅三智慧教育科技',
  settingsContractItemTitle: '卅三智慧教育科技服务协议',

  notFoundIcon: 0,

  aiPptChatHistoryFavoritesIcon: 0,
  aiPptChatLeftButtonIcon: 0,
  aiPptChatLeftButtonBg: '#e7eaf9',
  aiPptChatLeftButtonColor: '#4969fa',
  aiPptChatLeftButtonBorder: '#4969fa19',
  aiPptChatHeaderFavoritesIcon: 0,
  aiPptChatSendButtonIcon: 0,
  aiPptChatDeepCreationButtonColor: '#2174ec',
  aiPptChatDeepCreationButtonBg: 'rgba(66, 143, 255, 0.08)',
  aiPptChatDeepCreationButtonHoverBg: 'rgba(66, 143, 255, 0.3)',
  aiPptChatDeepCreationButtonIcon: 0,
  aiPptChatGenerateButtonIcon: 0,
  aiPptChatGenerateButtonHoverColor: '#526afe',
  hasAiPptChatDeepCreationDialogDescribe: true,

  moduleTabsBgColor: 'rgba(241, 241, 241, 0.8)',
  moduleTabsHoverBgColor: '#E4EBF9',

  resourceUnitGuideIcon: 0,
  resourceUnitGuideBg: 'rgba(66, 143, 255, 0.08)',
  resourceCommunityTextColor: 'rgba(68, 146, 255, 1)',
  resourceQuickCreateImage: 0,
  resourceQuickUploadImage: 0,
  resourceEmptyScaffoldImage: 0,
  resourceEmptyTeachingImage: 0,

  pptAddedButtonsBgColor: 'rgba(66, 143, 255, 1)',
  pptToolbarAddedBgColor:
    'linear-gradient(90.00deg, rgba(79.24977111816406, 207.8866729736328, 182.15928649902344, 1),rgba(69.68733215332031, 200.28668212890625, 145.99258422851562, 1) 100%)',

  resourceEmptyCoursewareImage: 0,

  communityCoursewareImage: 0,
  communityCoursewareBg: 'rgba(66, 143, 255, 0.08)',

  courseWareInfiniteCardButtonColor: '#428fff',
  courseWareInfiniteCardButtonColorHover: '#68a5ff',
  courseWareInfiniteCardButtonIcon: 0,
  courseWareInfiniteCardUseButtonColor: '#ffffff',
  courseWareInfiniteCardUseButtonColorHover: 'rgba(66, 143, 255, 0.12)',
  courseWareInfiniteCardUseButtonIcon: 0,
  courseWareInfiniteCardUseButtonBorder: '#428fff',
  courseWareInfiniteCardUseButtonFontColor: '#428fff',

  learningSpaceDocumentBg: 'rgba(66, 143, 255, 0.08);',
  learningSpaceDocumentImage: 0,

  agentMaterialBgImage: 0,
  agentMaterialTextColor: '#000000e0',
}));

export default useThemeStore;
